// AUTO-GENERATED — do not edit by hand.
// iamcal img-apple-64 filenames that KEEP the -fe0f suffix. An emoji whose
// fe0f-stripped hex sequence is in this set must be requested as
// `<codes>-fe0f.png`; every other emoji drops fe0f (Web A / Apple convention).
export const EMOJI_FE0F_KEEP: ReadonlySet<string> = new Set([
  "00a9",
  "00ae",
  "1f170",
  "1f171",
  "1f17e",
  "1f17f",
  "1f202",
  "1f237",
  "1f321",
  "1f324",
  "1f325",
  "1f326",
  "1f327",
  "1f328",
  "1f329",
  "1f32a",
  "1f32b",
  "1f32c",
  "1f336",
  "1f37d",
  "1f396",
  "1f397",
  "1f399",
  "1f39a",
  "1f39b",
  "1f39e",
  "1f39f",
  "1f3c3-200d-2640",
  "1f3c3-200d-2642",
  "1f3c3-200d-27a1",
  "1f3c4-200d-2640",
  "1f3c4-200d-2642",
  "1f3ca-200d-2640",
  "1f3ca-200d-2642",
  "1f3cb",
  "1f3cc",
  "1f3cd",
  "1f3ce",
  "1f3d4",
  "1f3d5",
  "1f3d6",
  "1f3d7",
  "1f3d8",
  "1f3d9",
  "1f3da",
  "1f3db",
  "1f3dc",
  "1f3dd",
  "1f3de",
  "1f3df",
  "1f3f3",
  "1f3f4-200d-2620",
  "1f3f5",
  "1f3f7",
  "1f43b-200d-2744",
  "1f43f",
  "1f441",
  "1f468-200d-1f9af-200d-27a1",
  "1f468-200d-1f9bc-200d-27a1",
  "1f468-200d-1f9bd-200d-27a1",
  "1f468-200d-2695",
  "1f468-200d-2696",
  "1f468-200d-2708",
  "1f469-200d-1f9af-200d-27a1",
  "1f469-200d-1f9bc-200d-27a1",
  "1f469-200d-1f9bd-200d-27a1",
  "1f469-200d-2695",
  "1f469-200d-2696",
  "1f469-200d-2708",
  "1f46e-200d-2640",
  "1f46e-200d-2642",
  "1f46f-200d-2640",
  "1f46f-200d-2642",
  "1f470-200d-2640",
  "1f470-200d-2642",
  "1f471-200d-2640",
  "1f471-200d-2642",
  "1f473-200d-2640",
  "1f473-200d-2642",
  "1f477-200d-2640",
  "1f477-200d-2642",
  "1f481-200d-2640",
  "1f481-200d-2642",
  "1f482-200d-2640",
  "1f482-200d-2642",
  "1f486-200d-2640",
  "1f486-200d-2642",
  "1f487-200d-2640",
  "1f487-200d-2642",
  "1f4fd",
  "1f549",
  "1f54a",
  "1f56f",
  "1f570",
  "1f573",
  "1f574",
  "1f575",
  "1f576",
  "1f577",
  "1f578",
  "1f579",
  "1f587",
  "1f58a",
  "1f58b",
  "1f58c",
  "1f58d",
  "1f590",
  "1f5a5",
  "1f5a8",
  "1f5b1",
  "1f5b2",
  "1f5bc",
  "1f5c2",
  "1f5c3",
  "1f5c4",
  "1f5d1",
  "1f5d2",
  "1f5d3",
  "1f5dc",
  "1f5dd",
  "1f5de",
  "1f5e1",
  "1f5e3",
  "1f5e8",
  "1f5ef",
  "1f5f3",
  "1f5fa",
  "1f636-200d-1f32b",
  "1f642-200d-2194",
  "1f642-200d-2195",
  "1f645-200d-2640",
  "1f645-200d-2642",
  "1f646-200d-2640",
  "1f646-200d-2642",
  "1f647-200d-2640",
  "1f647-200d-2642",
  "1f64b-200d-2640",
  "1f64b-200d-2642",
  "1f64d-200d-2640",
  "1f64d-200d-2642",
  "1f64e-200d-2640",
  "1f64e-200d-2642",
  "1f6a3-200d-2640",
  "1f6a3-200d-2642",
  "1f6b4-200d-2640",
  "1f6b4-200d-2642",
  "1f6b5-200d-2640",
  "1f6b5-200d-2642",
  "1f6b6-200d-2640",
  "1f6b6-200d-2642",
  "1f6b6-200d-27a1",
  "1f6cb",
  "1f6cd",
  "1f6ce",
  "1f6cf",
  "1f6e0",
  "1f6e1",
  "1f6e2",
  "1f6e3",
  "1f6e4",
  "1f6e5",
  "1f6e9",
  "1f6f0",
  "1f6f3",
  "1f926-200d-2640",
  "1f926-200d-2642",
  "1f935-200d-2640",
  "1f935-200d-2642",
  "1f937-200d-2640",
  "1f937-200d-2642",
  "1f938-200d-2640",
  "1f938-200d-2642",
  "1f939-200d-2640",
  "1f939-200d-2642",
  "1f93c-200d-2640",
  "1f93c-200d-2642",
  "1f93d-200d-2640",
  "1f93d-200d-2642",
  "1f93e-200d-2640",
  "1f93e-200d-2642",
  "1f9b8-200d-2640",
  "1f9b8-200d-2642",
  "1f9b9-200d-2640",
  "1f9b9-200d-2642",
  "1f9cd-200d-2640",
  "1f9cd-200d-2642",
  "1f9ce-200d-2640",
  "1f9ce-200d-2642",
  "1f9ce-200d-27a1",
  "1f9cf-200d-2640",
  "1f9cf-200d-2642",
  "1f9d1-200d-1f9af-200d-27a1",
  "1f9d1-200d-1f9bc-200d-27a1",
  "1f9d1-200d-1f9bd-200d-27a1",
  "1f9d1-200d-2695",
  "1f9d1-200d-2696",
  "1f9d1-200d-2708",
  "1f9d4-200d-2640",
  "1f9d4-200d-2642",
  "1f9d6-200d-2640",
  "1f9d6-200d-2642",
  "1f9d7-200d-2640",
  "1f9d7-200d-2642",
  "1f9d8-200d-2640",
  "1f9d8-200d-2642",
  "1f9d9-200d-2640",
  "1f9d9-200d-2642",
  "1f9da-200d-2640",
  "1f9da-200d-2642",
  "1f9db-200d-2640",
  "1f9db-200d-2642",
  "1f9dc-200d-2640",
  "1f9dc-200d-2642",
  "1f9dd-200d-2640",
  "1f9dd-200d-2642",
  "1f9de-200d-2640",
  "1f9de-200d-2642",
  "1f9df-200d-2640",
  "1f9df-200d-2642",
  "203c",
  "2049",
  "2122",
  "2139",
  "2194",
  "2195",
  "2196",
  "2197",
  "2198",
  "2199",
  "21a9",
  "21aa",
  "2328",
  "23cf",
  "23ed",
  "23ee",
  "23ef",
  "23f1",
  "23f2",
  "23f8",
  "23f9",
  "23fa",
  "24c2",
  "25aa",
  "25ab",
  "25b6",
  "25c0",
  "25fb",
  "25fc",
  "2600",
  "2601",
  "2602",
  "2603",
  "2604",
  "260e",
  "2611",
  "2618",
  "261d",
  "2620",
  "2622",
  "2623",
  "2626",
  "262a",
  "262e",
  "262f",
  "2638",
  "2639",
  "263a",
  "2640",
  "2642",
  "265f",
  "2660",
  "2663",
  "2665",
  "2666",
  "2668",
  "267b",
  "267e",
  "2692",
  "2694",
  "2695",
  "2696",
  "2697",
  "2699",
  "269b",
  "269c",
  "26a0",
  "26a7",
  "26b0",
  "26b1",
  "26c8",
  "26cf",
  "26d1",
  "26d3",
  "26e9",
  "26f0",
  "26f1",
  "26f4",
  "26f7",
  "26f8",
  "26f9",
  "2702",
  "2708",
  "2709",
  "270c",
  "270d",
  "270f",
  "2712",
  "2714",
  "2716",
  "271d",
  "2721",
  "2733",
  "2734",
  "2744",
  "2747",
  "2763",
  "2764",
  "27a1",
  "2934",
  "2935",
  "2b05",
  "2b06",
  "2b07",
  "3030",
  "303d",
  "3297",
  "3299",
]);
